export const KFJL = 'customerManager' // 客服经理
export const CSRMANAGER = 'csrManager' // 客服经理
export const SERVICE_MANAGER = 'serviceManager'// 服务经理
export const BW_ADMIN = 'bwadmin' // 管理员
export const MANAGER = 'manager' // 经理
export const SUPERVISOR = 'supervisor' // 总监
export const ACTIVITY_STAFFX = 'activityStaffX' // 活动专员
export const DATA_MANAGER = 'dataManager' // 数据经理
export const CUSTOMER_STAFF = 'customerStaff' // 专属邀约员
export const CSR_STAFF = 'csrStaff' // 客服专员
export const RECEPTIONIST_STAFF_ACCIDENT = 'receptionistStaffAccident' // 保险顾问(事故)
export const RESERVATION_STAFF_LIST = 'reservationStaffList' // 专属邀约员
export const RESERVATION_CUSTOMER_STAFF = 'reservationCustomerStaff' // 预约专员
export const RECEPTIONIST_STAFF = 'receptionistStaff' // 接待顾问
export const RECEPTIONIST_STAFF_ELECTRIC = 'receptionistStaffElectric' // 服务顾问
export const INSURANCE_MANAGER = 'insuranceManager' // 续保经理
export const INSURANCE_STAFF = 'insuranceStaff' // 续保专员
export const INSURANCE_INSIDE_JOB = 'insuranceInsideJob' // 续保内勤
export const AFTER_SALES_MANAGER = 'afterSalesManager' // 售后经理
export const FINANCE_STAFF = 'financeStaff' // 财务专员
export const UCT_MANAGER = 'uctManager' // 二手车经理
export const UCT_STAFF = 'uctStaff' // 二手车专员
export const SERVICE_MANAGER_ACCIDENT = 'serviceManagerOfAccident' // 服务经理（事故）
export const SERVICE_MANAGER_CONSULTANT = 'serviceConsultantOfAccident' // 服务顾问（事故）
export const MEMBER_ADMIN = 'memberAdmin' // 会员管理员
export const OUT_WORKER = 'outworker' // 外出核销人员



// WEBPACK FOOTER //
// ./src/constants/RoleCodeConstants.js